module.exports = __webpack_public_path__ + "img/colored-paper-6.fbcc96af.png";